import theme from './theme'

const config = {
  apiUrl: '/api',
  theme: theme
}

export default config
